import $ from 'jquery';

export class DataService {

    constructor(component) {
        this.component = component;
    }

    getExtractedData(batchId, extractionId, payload) {
        return new Promise((resolve, reject) => {
            try {
                $.ajax({
                    url: `/api/v1/extractions/${extractionId}/batches/${batchId}/data`,
                    type: 'POST',
                    data: JSON.stringify(payload),
                    contentType: 'application/json',
                    success: (res) => {
                        resolve(res);
                    },
                    error: (err) => {
                        reject(err);
                    }
                });
            } catch (error) {
                reject(error);
            }
        });
    }
}